module.exports = __webpack_public_path__ + "static/media/shop_image.daf8ae58.svg";